import { StoreBase } from "../cutil/StoreBase";
export class HomePluginStoreState {
    constructor() {
        this.disablePublishAsContent = false;
        /**
         * 是否通过cot创建的项目
         */
        this.initWithCot = false;
        //是否为分享链接
        this.isShare = false;
        //当前绑定的第3方domain
        this.customDomain = "";
    }
    copyWith(params) {
        const state = new HomePluginStoreState();
        state.disablePublishAsContent = params.disablePublishAsContent ?? this.disablePublishAsContent;
        state.initWithCot = params.initWithCot ?? this.initWithCot;
        state.isShare = params.isShare ?? this.isShare;
        state.customDomain = params.customDomain ?? this.customDomain;
        return state;
    }
}
export class HomePluginStore extends StoreBase {
    constructor() {
        super(() => {
            return new HomePluginStoreState();
        });
        this.undoData = { current: [] };
    }
    setState(param) {
        let newState = this.state.copyWith(param);
        this.emit(newState);
    }
    setDisablePublishAsContent(disablePublishAsContent) {
        this.setState({ disablePublishAsContent });
    }
    setInitWithCot(initWithCot) {
        this.setState({ initWithCot });
    }
    setIsShare(isShare) {
        this.setState({ isShare });
    }
    setCustomDomain(customDomain) {
        this.setState({ customDomain });
    }
}
